import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useTheme,
  Box,
} from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const CmsPage = ({ data }) => {
  const theme = useTheme();

  return (
    <Card elevation={3} sx={{ mb: 4, backgroundColor: theme.palette.gery.white }}>
      <CardContent>
        <Box display="flex" alignItems="center" mb={2}>
          <DescriptionIcon
            fontSize="small"
            sx={{ mr: 1, color: theme.palette.action.purpleLight }}
          />
          <Typography variant="h3" color="text.primary">
            CMS Pages
          </Typography>
        </Box>

        {Array.isArray(data) && data.length > 0 ? (
          data.map((page, index) => (
            <Accordion
              key={index}
              sx={{
                bgcolor: theme.palette.gery.lighter,
                borderRadius: 2,
                mb: 1,
                '&::before': { display: 'none' },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: theme.palette.icon }} />}
              >
                <Typography variant="smallMedium" color="text.primary">
                  {page.title || page.pageType}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="smallRegular" color="text.secondary">
                  {page.description || 'No content available.'}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))
        ) : (
          <Typography variant="smallRegular" color="text.secondary">
            No CMS pages available.
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default CmsPage;
